import { useCallback } from "react"
import client from "utils/client"
import { useQuery, useQueryClient } from "@tanstack/react-query"

const policyQuery = (name, params) => ({
  queryKey: ["policies", name, params],
  queryFn: async () => {
    const response = await client.get(`/policies/${name}.json`, { params })
    return response.data
  },
  staleTime: Infinity,
  cacheTime: Infinity
})

/**
 * @param {string} name
 * @param {object} params
 * @param {import("@tanstack/react-query").UseQueryOptions} config
 */
export const usePolicy = (name, params = {}, config = {}) => {
  return useQuery({
    ...policyQuery(name, params),
    ...config
  })
}

export const useResolvePolicy = () => {
  const queryClient = useQueryClient()

  return useCallback(
    async (name, action, params = {}) => {
      const data = await queryClient.fetchQuery(
        policyQuery(name, { action_name: action, ...params })
      )
      return Boolean(data?.[action])
    },
    [queryClient]
  )
}
